module.exports = __webpack_public_path__ + "img/syukyaku-de-001.222bb87b.jpg";